import { render, staticRenderFns } from "./SegmentationLimiterDataSelect.vue?vue&type=template&id=0d8f4e71&scoped=true"
import script from "./SegmentationLimiterDataSelect.vue?vue&type=script&lang=js"
export * from "./SegmentationLimiterDataSelect.vue?vue&type=script&lang=js"
import style0 from "./SegmentationLimiterDataSelect.vue?vue&type=style&index=0&id=0d8f4e71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8f4e71",
  null
  
)

export default component.exports